import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "../App";
import './MainScreen.css'
import MenuRow from "./items/promo/MenuRow";
import {ICity} from "./model/B2CInfo";
import HeaderLogo from "./HeaderLogo";
import UserAvatar from "./header/Avatar";

interface IHeaderProps {
    avatarUrl: string,
    name: string,
    city: ICity,
    onSelected: (city: ICity) => void
}

export default function Header(props: IHeaderProps) {
    const [active, setActive] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [translate, setTranslate] = useState(0);
    const [smallMenu, setSmallMenu] = useState(false);

    const appContext = useContext(AppContext);

    // @ts-ignore
    const handleScroll = (event) => {
        const scroll =
            document.body.scrollTop || document.documentElement.scrollTop;
        // setTranslate(Math.min(-scroll, 0));
        if (scroll > 72) {
            setTranslate(0);
            setActive(true);
            setShowMenu(true)
        } else {
            setActive(false);
            setShowMenu(false);
            setTranslate(Math.min(-(Math.min(176, scroll)), 0));
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, []);

    React.useEffect(() => {
        function handleResize() {
            setSmallMenu(window.innerWidth < 1500)
        }
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize);
    }, [])

    let menu = <MenuRow city={props.city} onSelected={props.onSelected}/>

    return (
        <div className={"Header"}>
            <div
                className={"Header_links" + (showMenu ? " Header_links_fixed" : "") + (active ? " Header_active" : "")}>
                <HeaderLogo key={showMenu ? "show" : "hide"} isLarge={!showMenu || !smallMenu}/>
                {!showMenu &&
                <div className="Header_Menu">
                    <a href={window.location.href} className="Header_Menu_Item_Selected">Каршеринг</a>
                    <a href="https://yandex.ru/drive/podpiska" className="Header_Menu_Item">Подписка</a>
                    <a href="https://yandex.ru/drive/b2b" className="Header_Menu_Item">Для бизнеса</a>
                </div>
                }
                {showMenu && <div className="Header_menu_row_fixed">{menu}</div>}
                <div className="Header_Avatar_Container">
                    {(!showMenu || !smallMenu) && <div className="Header_Avatar_Title">{props.name}</div>}
                    <UserAvatar url={props.avatarUrl} styleClass={"Header_Avatar_Image"}/>
                </div>
            </div>
            {!showMenu && <div className="Header_navigation_menu">{menu}</div>}
        </div>
    );
}